import { useEffect, useState } from "react";
import { COLORS, ComparisonChart } from "@/components/Charts";
import { api } from "@/lib/api";
import { num } from "@/lib/format";
import { Card } from "@/components/Kpi";

/** Istogramma mensile dei DB Conto Carta (anno vs precedente), totale rete o singola agenzia. */
export function ContoCartaChart({ anno, agenzia, escludi, height = 300 }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const p = new URLSearchParams({ anno });
    if (agenzia) p.set("agenzia", agenzia);
    if (escludi) p.set("escludi", escludi);
    api.get(`/corto/conto-carta?${p}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [anno, agenzia, escludi]);
  if (!d) return null;
  if (!d.disponibile) {
    return (
      <Card className="p-6" data-testid="corto-conto-carta-vuoto">
        <div className="uppercase text-xs tracking-[0.18em] font-semibold text-slate-500">DB Conto Carta</div>
        <p className="text-sm text-slate-500 mt-2">
          Nessun file caricato. Vai in <span className="font-semibold">Impostazioni → Configurazioni corto → DB Conto Carta</span> e
          carica il file "DB CONTO CARTA estrazione AAAA.xlsx": l'istogramma comparirà qui e in ogni scheda agenzia.
        </p>
      </Card>
    );
  }
  const keys = [{ key: "corrente", name: String(d.anno), color: "#A855F7" }];
  if (d.totale_precedente) keys.unshift({ key: "precedente", name: String(d.anno_precedente), color: COLORS.grigio });
  return (
    <ComparisonChart testId="corto-conto-carta-chart" height={height} labelFormat="int"
      title={`DB Conto Carta ${agenzia ? `· ${agenzia}` : "· rete"} · ${num(d.totale)} nel ${d.anno}`}
      data={d.serie} keys={keys} />
  );
}
